import React, { useMemo } from 'react';
import { TermsLinks } from '../../shared/components/terms-links';

// TODO: Add Proptypes or Implement Typescipt

// TODO: Refactor axp-benefits-terms-modal to take in ReadLB data. Currently calls legacy bdaas for data

export default function TermsModal(props) {
  const { cardname, location, quickViewTermsModal, benefitNameTag, fromViewAll, localeDetails } = props;
  const pathname = useMemo(() => location?.pathname?.toLowerCase(), [location?.pathname]);
  const actionTag = useMemo(() => `${cardname}>>view-all`, [cardname]);

  return (
    <div className={fromViewAll === true ? 'pad-responsive stack flex flex-column flex-justify-center text-nowrap margin-0-lr margin-1-b width-full' : ''}>
      <TermsLinks cardname={cardname} pathname={pathname} actionTag={actionTag} quickViewTermsModal={quickViewTermsModal} benefitNameTag={benefitNameTag} localeDetails={localeDetails} />
    </div>
  );
}
